import { post } from 'app/shared/utils/fetchr';

// Models
import { PaginationPayload } from 'app/shared/models';
import { CreateBlacklistPayload } from 'app/modules/lists/requests';

// Utils
import routes from 'app/shared/utils/routes';

export const retrieveBlacklists = (payload: PaginationPayload) => {
  return post(routes.patronus.blacklistsList, payload);
};

export const createBlacklist = (payload: CreateBlacklistPayload) => {
  return post(routes.patronus.blacklistsCreate, payload);
};
